import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, ContentChildren, Input, Output, NgModule } from '@angular/core';
import DxDiagram from 'devextreme/ui/diagram';
import * as i1 from 'devextreme-angular/core';
import { DxComponent, DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper, DxIntegrationModule, DxTemplateModule } from 'devextreme-angular/core';
import { DxoContextMenuModule, DxiCommandModule, DxiItemModule, DxoContextToolboxModule, DxiCustomShapeModule, DxiConnectionPointModule, DxoDefaultItemPropertiesModule, DxoEdgesModule, DxoEditingModule, DxoExportModule, DxoGridSizeModule, DxoHistoryToolbarModule, DxoMainToolbarModule, DxoNodesModule, DxoAutoLayoutModule, DxoPageSizeModule, DxoPropertiesPanelModule, DxiTabModule, DxiGroupModule, DxoToolboxModule, DxoViewToolbarModule, DxoZoomLevelModule } from 'devextreme-angular/ui/nested';
import { DxoDiagramAutoLayoutModule, DxiDiagramCommandModule, DxiDiagramCommandItemModule, DxiDiagramConnectionPointModule, DxoDiagramContextMenuModule, DxoDiagramContextToolboxModule, DxiDiagramCustomShapeModule, DxoDiagramDefaultItemPropertiesModule, DxoDiagramEdgesModule, DxoDiagramEditingModule, DxoDiagramExportModule, DxoDiagramGridSizeModule, DxiDiagramGroupModule, DxoDiagramHistoryToolbarModule, DxiDiagramItemModule, DxoDiagramMainToolbarModule, DxoDiagramNodesModule, DxoDiagramPageSizeModule, DxiDiagramPageSizeItemModule, DxoDiagramPropertiesPanelModule, DxiDiagramTabModule, DxiDiagramTabGroupModule, DxoDiagramToolboxModule, DxiDiagramToolboxGroupModule, DxoDiagramViewToolbarModule, DxoDiagramZoomLevelModule } from 'devextreme-angular/ui/diagram/nested';
export * from 'devextreme-angular/ui/diagram/nested';
import { PROPERTY_TOKEN_commands, PROPERTY_TOKEN_items, PROPERTY_TOKEN_connectionPoints, PROPERTY_TOKEN_customShapes, PROPERTY_TOKEN_groups, PROPERTY_TOKEN_tabs } from 'devextreme-angular/core/tokens';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/**
 * The Diagram UI component provides a visual interface to help you design new and modify existing diagrams.

 */
let DxDiagramComponent = /*#__PURE__*/(() => {
  class DxDiagramComponent extends DxComponent {
    _watcherHelper;
    _idh;
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    set _connectionPointsContentChildren(value) {
      this.setChildren('connectionPoints', value);
    }
    set _customShapesContentChildren(value) {
      this.setChildren('customShapes', value);
    }
    set _groupsContentChildren(value) {
      this.setChildren('groups', value);
    }
    set _tabsContentChildren(value) {
      this.setChildren('tabs', value);
    }
    instance = null;
    /**
     * Specifies how the Diagram UI component automatically zooms the work area.
    
     */
    get autoZoomMode() {
      return this._getOption('autoZoomMode');
    }
    set autoZoomMode(value) {
      this._setOption('autoZoomMode', value);
    }
    /**
     * Configures the context menu&apos;s settings.
    
     */
    get contextMenu() {
      return this._getOption('contextMenu');
    }
    set contextMenu(value) {
      this._setOption('contextMenu', value);
    }
    /**
     * Configures the context toolbox&apos;s settings.
    
     */
    get contextToolbox() {
      return this._getOption('contextToolbox');
    }
    set contextToolbox(value) {
      this._setOption('contextToolbox', value);
    }
    /**
     * Provide access to an array of custom shapes.
    
     */
    get customShapes() {
      return this._getOption('customShapes');
    }
    set customShapes(value) {
      this._setOption('customShapes', value);
    }
    /**
     * Specifies a custom template for shapes.
    
     */
    get customShapeTemplate() {
      return this._getOption('customShapeTemplate');
    }
    set customShapeTemplate(value) {
      this._setOption('customShapeTemplate', value);
    }
    /**
     * Specifies a custom template for shapes in the toolbox.
    
     */
    get customShapeToolboxTemplate() {
      return this._getOption('customShapeToolboxTemplate');
    }
    set customShapeToolboxTemplate(value) {
      this._setOption('customShapeToolboxTemplate', value);
    }
    /**
     * Configures default item properties.
    
     */
    get defaultItemProperties() {
      return this._getOption('defaultItemProperties');
    }
    set defaultItemProperties(value) {
      this._setOption('defaultItemProperties', value);
    }
    /**
     * Specifies whether the UI component responds to user interaction.
    
     */
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    /**
     * Allows you to bind the collection of diagram edges to a data source. For more information, see the Data Binding section.
    
     */
    get edges() {
      return this._getOption('edges');
    }
    set edges(value) {
      this._setOption('edges', value);
    }
    /**
     * Specifies which editing operations a user can perform.
    
     */
    get editing() {
      return this._getOption('editing');
    }
    set editing(value) {
      this._setOption('editing', value);
    }
    /**
     * Specifies the global attributes to be attached to the UI component&apos;s container element.
    
     */
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    /**
     * Configures export settings.
    
     */
    get export() {
      return this._getOption('export');
    }
    set export(value) {
      this._setOption('export', value);
    }
    /**
     * Specifies whether or not to display the UI component in full-screen mode.
    
     */
    get fullScreen() {
      return this._getOption('fullScreen');
    }
    set fullScreen(value) {
      this._setOption('fullScreen', value);
    }
    /**
     * Specifies the grid pitch.
    
     */
    get gridSize() {
      return this._getOption('gridSize');
    }
    set gridSize(value) {
      this._setOption('gridSize', value);
    }
    /**
     * Indicates whether diagram content has unsaved changes.
    
     */
    get hasChanges() {
      return this._getOption('hasChanges');
    }
    set hasChanges(value) {
      this._setOption('hasChanges', value);
    }
    /**
     * Specifies the UI component&apos;s height.
    
     */
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    /**
     * Configures the history toolbar&apos;s settings.
    
     */
    get historyToolbar() {
      return this._getOption('historyToolbar');
    }
    set historyToolbar(value) {
      this._setOption('historyToolbar', value);
    }
    /**
     * Configures the main toolbar settings.
    
     */
    get mainToolbar() {
      return this._getOption('mainToolbar');
    }
    set mainToolbar(value) {
      this._setOption('mainToolbar', value);
    }
    /**
     * Allows you to bind the collection of diagram nodes to a data source. For more information, see the Data Binding section.
    
     */
    get nodes() {
      return this._getOption('nodes');
    }
    set nodes(value) {
      this._setOption('nodes', value);
    }
    /**
     * Specifies the color of a diagram page.
    
     */
    get pageColor() {
      return this._getOption('pageColor');
    }
    set pageColor(value) {
      this._setOption('pageColor', value);
    }
    /**
     * Specifies the page orientation.
    
     */
    get pageOrientation() {
      return this._getOption('pageOrientation');
    }
    set pageOrientation(value) {
      this._setOption('pageOrientation', value);
    }
    /**
     * Specifies a size of pages.
    
     */
    get pageSize() {
      return this._getOption('pageSize');
    }
    set pageSize(value) {
      this._setOption('pageSize', value);
    }
    /**
     * Configures the Properties panel settings.
    
     */
    get propertiesPanel() {
      return this._getOption('propertiesPanel');
    }
    set propertiesPanel(value) {
      this._setOption('propertiesPanel', value);
    }
    /**
     * Specifies whether the diagram is read-only.
    
     */
    get readOnly() {
      return this._getOption('readOnly');
    }
    set readOnly(value) {
      this._setOption('readOnly', value);
    }
    /**
     * Switches the UI component to a right-to-left representation.
    
     */
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    /**
     * Specifies whether grid lines are visible.
    
     */
    get showGrid() {
      return this._getOption('showGrid');
    }
    set showGrid(value) {
      this._setOption('showGrid', value);
    }
    /**
     * Switch the Diagram UI component to simple view mode.
    
     */
    get simpleView() {
      return this._getOption('simpleView');
    }
    set simpleView(value) {
      this._setOption('simpleView', value);
    }
    /**
     * Specifies whether diagram elements should snap to grid lines.
    
     */
    get snapToGrid() {
      return this._getOption('snapToGrid');
    }
    set snapToGrid(value) {
      this._setOption('snapToGrid', value);
    }
    /**
     * Configures the toolbox settings.
    
     */
    get toolbox() {
      return this._getOption('toolbox');
    }
    set toolbox(value) {
      this._setOption('toolbox', value);
    }
    /**
     * Specifies the measurement unit for size properties.
    
     */
    get units() {
      return this._getOption('units');
    }
    set units(value) {
      this._setOption('units', value);
    }
    /**
     * Specifies whether or not the UI component uses native scrolling.
    
     */
    get useNativeScrolling() {
      return this._getOption('useNativeScrolling');
    }
    set useNativeScrolling(value) {
      this._setOption('useNativeScrolling', value);
    }
    /**
     * Configures the view toolbar settings.
    
     */
    get viewToolbar() {
      return this._getOption('viewToolbar');
    }
    set viewToolbar(value) {
      this._setOption('viewToolbar', value);
    }
    /**
     * Specifies the measurement unit that is displayed in user interface elements.
    
     */
    get viewUnits() {
      return this._getOption('viewUnits');
    }
    set viewUnits(value) {
      this._setOption('viewUnits', value);
    }
    /**
     * Specifies whether the UI component is visible.
    
     */
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /**
     * Specifies the UI component&apos;s width.
    
     */
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
     * Specifies the zoom level.
    
     */
    get zoomLevel() {
      return this._getOption('zoomLevel');
    }
    set zoomLevel(value) {
      this._setOption('zoomLevel', value);
    }
    /**
    
     * A function that is executed when the UI component is rendered and each time the component is repainted.
    
    
     */
    onContentReady;
    /**
    
     * A function that is executed after a custom command item was clicked and allows you to implement the custom command&apos;s logic.
    
    
     */
    onCustomCommand;
    /**
    
     * A function that is executed before the UI component is disposed of.
    
    
     */
    onDisposing;
    /**
    
     * A function used in JavaScript frameworks to save the UI component instance.
    
    
     */
    onInitialized;
    /**
    
     * A function that is executed after a shape or connector is clicked.
    
    
     */
    onItemClick;
    /**
    
     * A function that is executed after a shape or connector is double-clicked.
    
    
     */
    onItemDblClick;
    /**
    
     * A function that is executed after a UI component property is changed.
    
    
     */
    onOptionChanged;
    /**
    
     * A function that allows you to prohibit an edit operation at run time.
    
    
     */
    onRequestEditOperation;
    /**
    
     * A function that allows you to specify whether or not the UI component should reapply its auto layout after diagram data is reloaded.
    
    
     */
    onRequestLayoutUpdate;
    /**
    
     * A function that is executed after the selection is changed in the Diagram.
    
    
     */
    onSelectionChanged;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    autoZoomModeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    contextMenuChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    contextToolboxChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    customShapesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    customShapeTemplateChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    customShapeToolboxTemplateChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    defaultItemPropertiesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    disabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    edgesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    editingChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    elementAttrChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    exportChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    fullScreenChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    gridSizeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    hasChangesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    historyToolbarChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    mainToolbarChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    nodesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pageColorChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pageOrientationChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pageSizeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    propertiesPanelChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    readOnlyChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    rtlEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showGridChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    simpleViewChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    snapToGridChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    toolboxChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    unitsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    useNativeScrollingChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    viewToolbarChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    viewUnitsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    zoomLevelChange;
    constructor(elementRef, ngZone, templateHost, _watcherHelper, _idh, optionHost, transferState, platformId) {
      super(elementRef, ngZone, templateHost, _watcherHelper, transferState, platformId);
      this._watcherHelper = _watcherHelper;
      this._idh = _idh;
      this._createEventEmitters([{
        subscribe: 'contentReady',
        emit: 'onContentReady'
      }, {
        subscribe: 'customCommand',
        emit: 'onCustomCommand'
      }, {
        subscribe: 'disposing',
        emit: 'onDisposing'
      }, {
        subscribe: 'initialized',
        emit: 'onInitialized'
      }, {
        subscribe: 'itemClick',
        emit: 'onItemClick'
      }, {
        subscribe: 'itemDblClick',
        emit: 'onItemDblClick'
      }, {
        subscribe: 'optionChanged',
        emit: 'onOptionChanged'
      }, {
        subscribe: 'requestEditOperation',
        emit: 'onRequestEditOperation'
      }, {
        subscribe: 'requestLayoutUpdate',
        emit: 'onRequestLayoutUpdate'
      }, {
        subscribe: 'selectionChanged',
        emit: 'onSelectionChanged'
      }, {
        emit: 'autoZoomModeChange'
      }, {
        emit: 'contextMenuChange'
      }, {
        emit: 'contextToolboxChange'
      }, {
        emit: 'customShapesChange'
      }, {
        emit: 'customShapeTemplateChange'
      }, {
        emit: 'customShapeToolboxTemplateChange'
      }, {
        emit: 'defaultItemPropertiesChange'
      }, {
        emit: 'disabledChange'
      }, {
        emit: 'edgesChange'
      }, {
        emit: 'editingChange'
      }, {
        emit: 'elementAttrChange'
      }, {
        emit: 'exportChange'
      }, {
        emit: 'fullScreenChange'
      }, {
        emit: 'gridSizeChange'
      }, {
        emit: 'hasChangesChange'
      }, {
        emit: 'heightChange'
      }, {
        emit: 'historyToolbarChange'
      }, {
        emit: 'mainToolbarChange'
      }, {
        emit: 'nodesChange'
      }, {
        emit: 'pageColorChange'
      }, {
        emit: 'pageOrientationChange'
      }, {
        emit: 'pageSizeChange'
      }, {
        emit: 'propertiesPanelChange'
      }, {
        emit: 'readOnlyChange'
      }, {
        emit: 'rtlEnabledChange'
      }, {
        emit: 'showGridChange'
      }, {
        emit: 'simpleViewChange'
      }, {
        emit: 'snapToGridChange'
      }, {
        emit: 'toolboxChange'
      }, {
        emit: 'unitsChange'
      }, {
        emit: 'useNativeScrollingChange'
      }, {
        emit: 'viewToolbarChange'
      }, {
        emit: 'viewUnitsChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }, {
        emit: 'zoomLevelChange'
      }]);
      this._idh.setHost(this);
      optionHost.setHost(this);
    }
    _createInstance(element, options) {
      return new DxDiagram(element, options);
    }
    ngOnDestroy() {
      this._destroyWidget();
    }
    ngOnChanges(changes) {
      super.ngOnChanges(changes);
      this.setupChanges('customShapes', changes);
    }
    setupChanges(prop, changes) {
      if (!(prop in this._optionsToUpdate)) {
        this._idh.setup(prop, changes);
      }
    }
    ngDoCheck() {
      this._idh.doCheck('customShapes');
      this._watcherHelper.checkWatchers();
      super.ngDoCheck();
      super.clearChangedOptions();
    }
    _setOption(name, value) {
      let isSetup = this._idh.setupSingle(name, value);
      let isChanged = this._idh.getChanges(name, value) !== null;
      if (isSetup || isChanged) {
        super._setOption(name, value);
      }
    }
    /** @nocollapse */
    static ɵfac = function DxDiagramComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxDiagramComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.DxTemplateHost), i0.ɵɵdirectiveInject(i1.WatcherHelper), i0.ɵɵdirectiveInject(i1.IterableDifferHelper), i0.ɵɵdirectiveInject(i1.NestedOptionHost), i0.ɵɵdirectiveInject(i0.TransferState), i0.ɵɵdirectiveInject(PLATFORM_ID));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxDiagramComponent,
      selectors: [["dx-diagram"]],
      contentQueries: function DxDiagramComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_connectionPoints, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_customShapes, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_groups, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_tabs, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._connectionPointsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._customShapesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groupsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabsContentChildren = _t);
        }
      },
      hostAttrs: ["ngSkipHydration", "true"],
      inputs: {
        autoZoomMode: "autoZoomMode",
        contextMenu: "contextMenu",
        contextToolbox: "contextToolbox",
        customShapes: "customShapes",
        customShapeTemplate: "customShapeTemplate",
        customShapeToolboxTemplate: "customShapeToolboxTemplate",
        defaultItemProperties: "defaultItemProperties",
        disabled: "disabled",
        edges: "edges",
        editing: "editing",
        elementAttr: "elementAttr",
        export: "export",
        fullScreen: "fullScreen",
        gridSize: "gridSize",
        hasChanges: "hasChanges",
        height: "height",
        historyToolbar: "historyToolbar",
        mainToolbar: "mainToolbar",
        nodes: "nodes",
        pageColor: "pageColor",
        pageOrientation: "pageOrientation",
        pageSize: "pageSize",
        propertiesPanel: "propertiesPanel",
        readOnly: "readOnly",
        rtlEnabled: "rtlEnabled",
        showGrid: "showGrid",
        simpleView: "simpleView",
        snapToGrid: "snapToGrid",
        toolbox: "toolbox",
        units: "units",
        useNativeScrolling: "useNativeScrolling",
        viewToolbar: "viewToolbar",
        viewUnits: "viewUnits",
        visible: "visible",
        width: "width",
        zoomLevel: "zoomLevel"
      },
      outputs: {
        onContentReady: "onContentReady",
        onCustomCommand: "onCustomCommand",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onItemClick: "onItemClick",
        onItemDblClick: "onItemDblClick",
        onOptionChanged: "onOptionChanged",
        onRequestEditOperation: "onRequestEditOperation",
        onRequestLayoutUpdate: "onRequestLayoutUpdate",
        onSelectionChanged: "onSelectionChanged",
        autoZoomModeChange: "autoZoomModeChange",
        contextMenuChange: "contextMenuChange",
        contextToolboxChange: "contextToolboxChange",
        customShapesChange: "customShapesChange",
        customShapeTemplateChange: "customShapeTemplateChange",
        customShapeToolboxTemplateChange: "customShapeToolboxTemplateChange",
        defaultItemPropertiesChange: "defaultItemPropertiesChange",
        disabledChange: "disabledChange",
        edgesChange: "edgesChange",
        editingChange: "editingChange",
        elementAttrChange: "elementAttrChange",
        exportChange: "exportChange",
        fullScreenChange: "fullScreenChange",
        gridSizeChange: "gridSizeChange",
        hasChangesChange: "hasChangesChange",
        heightChange: "heightChange",
        historyToolbarChange: "historyToolbarChange",
        mainToolbarChange: "mainToolbarChange",
        nodesChange: "nodesChange",
        pageColorChange: "pageColorChange",
        pageOrientationChange: "pageOrientationChange",
        pageSizeChange: "pageSizeChange",
        propertiesPanelChange: "propertiesPanelChange",
        readOnlyChange: "readOnlyChange",
        rtlEnabledChange: "rtlEnabledChange",
        showGridChange: "showGridChange",
        simpleViewChange: "simpleViewChange",
        snapToGridChange: "snapToGridChange",
        toolboxChange: "toolboxChange",
        unitsChange: "unitsChange",
        useNativeScrollingChange: "useNativeScrollingChange",
        viewToolbarChange: "viewToolbarChange",
        viewUnitsChange: "viewUnitsChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange",
        zoomLevelChange: "zoomLevelChange"
      },
      features: [i0.ɵɵProvidersFeature([DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      decls: 0,
      vars: 0,
      template: function DxDiagramComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxDiagramComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxDiagramModule = /*#__PURE__*/(() => {
  class DxDiagramModule {
    /** @nocollapse */static ɵfac = function DxDiagramModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxDiagramModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxDiagramModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxDiagramComponent, DxoContextMenuModule, DxiCommandModule, DxiItemModule, DxoContextToolboxModule, DxiCustomShapeModule, DxiConnectionPointModule, DxoDefaultItemPropertiesModule, DxoEdgesModule, DxoEditingModule, DxoExportModule, DxoGridSizeModule, DxoHistoryToolbarModule, DxoMainToolbarModule, DxoNodesModule, DxoAutoLayoutModule, DxoPageSizeModule, DxoPropertiesPanelModule, DxiTabModule, DxiGroupModule, DxoToolboxModule, DxoViewToolbarModule, DxoZoomLevelModule, DxoDiagramAutoLayoutModule, DxiDiagramCommandModule, DxiDiagramCommandItemModule, DxiDiagramConnectionPointModule, DxoDiagramContextMenuModule, DxoDiagramContextToolboxModule, DxiDiagramCustomShapeModule, DxoDiagramDefaultItemPropertiesModule, DxoDiagramEdgesModule, DxoDiagramEditingModule, DxoDiagramExportModule, DxoDiagramGridSizeModule, DxiDiagramGroupModule, DxoDiagramHistoryToolbarModule, DxiDiagramItemModule, DxoDiagramMainToolbarModule, DxoDiagramNodesModule, DxoDiagramPageSizeModule, DxiDiagramPageSizeItemModule, DxoDiagramPropertiesPanelModule, DxiDiagramTabModule, DxiDiagramTabGroupModule, DxoDiagramToolboxModule, DxiDiagramToolboxGroupModule, DxoDiagramViewToolbarModule, DxoDiagramZoomLevelModule, DxIntegrationModule, DxTemplateModule, DxoContextMenuModule, DxiCommandModule, DxiItemModule, DxoContextToolboxModule, DxiCustomShapeModule, DxiConnectionPointModule, DxoDefaultItemPropertiesModule, DxoEdgesModule, DxoEditingModule, DxoExportModule, DxoGridSizeModule, DxoHistoryToolbarModule, DxoMainToolbarModule, DxoNodesModule, DxoAutoLayoutModule, DxoPageSizeModule, DxoPropertiesPanelModule, DxiTabModule, DxiGroupModule, DxoToolboxModule, DxoViewToolbarModule, DxoZoomLevelModule, DxoDiagramAutoLayoutModule, DxiDiagramCommandModule, DxiDiagramCommandItemModule, DxiDiagramConnectionPointModule, DxoDiagramContextMenuModule, DxoDiagramContextToolboxModule, DxiDiagramCustomShapeModule, DxoDiagramDefaultItemPropertiesModule, DxoDiagramEdgesModule, DxoDiagramEditingModule, DxoDiagramExportModule, DxoDiagramGridSizeModule, DxiDiagramGroupModule, DxoDiagramHistoryToolbarModule, DxiDiagramItemModule, DxoDiagramMainToolbarModule, DxoDiagramNodesModule, DxoDiagramPageSizeModule, DxiDiagramPageSizeItemModule, DxoDiagramPropertiesPanelModule, DxiDiagramTabModule, DxiDiagramTabGroupModule, DxoDiagramToolboxModule, DxiDiagramToolboxGroupModule, DxoDiagramViewToolbarModule, DxoDiagramZoomLevelModule, DxTemplateModule]
    });
  }
  return DxDiagramModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DxDiagramComponent, DxDiagramModule };
